var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCarRepair64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 28.6553H56.0429C58.7803 28.6553 60.9994 30.8744 60.9994 33.6117V42.2856H8.95647C6.21908 42.2856 4 40.0665 4 37.3291V28.6553Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5637 41.6659C22.5637 44.7456 20.067 47.2419 16.9882 47.2419C13.9083 47.2419 11.4116 44.7456 11.4116 41.6659C11.4116 38.5861 13.9083 36.0898 16.9882 36.0898C20.067 36.0898 22.5637 38.5861 22.5637 41.6659Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7805 41.6659C54.7805 44.7456 52.2838 47.2419 49.205 47.2419C46.1251 47.2419 43.6284 44.7456 43.6284 41.6659C43.6284 38.5861 46.1251 36.0898 49.205 36.0898C52.2838 36.0898 54.7805 38.5861 54.7805 41.6659Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6137 19.471C20.435 18.3841 22.2159 17.5029 23.5865 17.5029H35.2183C36.5911 17.5029 38.3793 18.3967 39.1911 19.471L46.1305 28.655H12.6743L19.6137 19.471Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1304 28.6553L53.39 21.3957C54.171 20.6146 55.4374 20.6146 56.2184 21.3957L57.2824 22.4597",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCarRepair64);
export default __webpack_public_path__ + "static/media/pictogramBeaconCarRepair64.4f5c2462c16f2d036cd954027bb547cb.svg";
export { ForwardRef as ReactComponent };